import { Type, Transform } from 'class-transformer'
import { DateTime, Duration } from 'luxon'
import { NurseTier, PaymentOption, Role } from 'types/types'

export default class AvailabilityCheck {
    id!: number
    
    @Type(() => DateTime)
    @Transform(({ value }) => DateTime.fromISO(value))
    start_at!: DateTime
    
    @Type(() => DateTime)
    @Transform(({ value }) => DateTime.fromISO(value))
    end_at!: DateTime

    @Type(() => Duration)
    @Transform(({ value }) => Duration.fromMillis(1000 * Number(value)))
    lunch_break!: Duration

    postcode!: string
    lat!: number
    lng!: number
    practice_name!: string
    payment_option!: PaymentOption
    settlement_days!: number
    role!: Role
    tiers!: NurseTier[]
    sedation_required!: boolean
    radiography_required!: boolean
    implant_required!: boolean
    orthodontics_required!: boolean

    @Type(() => DateTime)
    @Transform(({ value }) => DateTime.fromISO(value))
    created_at!: DateTime

    // annotate is_expired
    is_expired!: boolean

    // annotate num_results
    num_available!: number
    num_unavailable!: number
    num_pending!: number
}